<template>
    <div>Sheets1 | Sheet 2 | Sheet 3</div>
</template>

<script>
  export default {
    name: "SheetSelector"
  }
</script>
